// extracted by mini-css-extract-plugin
module.exports = {"list-sections":"styles_list-sections__JQ0W_"};